import React, { useLayoutEffect } from 'react';
import CheckboxInput from '../CheckboxInput';
import { jsx as _jsx } from "react/jsx-runtime";
const DataRetentionIndefinite = _ref => {
  let {
    value,
    options,
    onChange,
    fieldName,
    isDataRetentionSupported
  } = _ref;
  useLayoutEffect(() => {
    /*
    On initial render, when the root question is true and the initial value this question is "null/undefined",
    scenario: 
      - previously there is no data for this question
      - user select > yes for > Does your app store End-User Data after a customer uninstalls your app?
      - now there is no value for this however its a checkbox and it should either be true or false otherwise how will you differentiate between null/undefined/false
    */
    if (isDataRetentionSupported && (value === undefined || value === null)) {
      onChange(false);
    }
  }, [isDataRetentionSupported]);
  return /*#__PURE__*/_jsx(CheckboxInput, {
    value: value,
    options: options,
    onChange: onChange,
    fieldName: fieldName
  });
};
export default DataRetentionIndefinite;